module.exports = __webpack_public_path__ + "static/media/factory-card.da793611.png";